import cn from 'clsx'

import { type Hero as HeroType } from '../../../../../apps/benmax/src/types/sanity.types'

import { Copy, ImageBox, Button } from 'shared-components'

import { getSanityLink } from 'shared-functions'

import s from './Hero.module.sass'

function Hero({ title, copy, image, link, blueBackground }: HeroType) {
    const _link = link?.linkType === 'internal' || link?.linkType === 'external' ? getSanityLink(link) || null : null

    return (
        <section className={cn(s.Hero, blueBackground && s.BlueBackground)}>
            <div className={cn(s.Cont, 'container')}>
                <div className={s.Main}>
                    <div className={s.Content}>
                        {title && <h1 dangerouslySetInnerHTML={{ __html: title }} />}
                        {copy && (
                            <div className={s.Copy}>
                                <Copy copy={copy} />
                            </div>
                        )}
                    </div>
                </div>
                <div className={s.Image}>
                    {image && <ImageBox image={image} width={800} height={800} priority />}
                    {_link && <Button url={_link?.url || ''} title={_link?.title || ''} className={s.Link} inverted />}
                </div>
            </div>
        </section>
    )
}

export default Hero
